import { createElement as h } from "react"

import { useDynamicStyles } from "./css"
import { getStatus } from "./lib"
import i18n from "../../../lib/i18n.es6"

export const Status = ({ status, statusType }) => {
  const settings = getStatus(status, statusType) || {}

  const { root } = useDynamicStyles({ color: settings.color })

  return h("div", { className: root }, i18n(settings.name))
}
